module.exports = __webpack_public_path__ + "static/media/hd-signature.35334ccd.png";